module.exports = __webpack_public_path__ + "img/anluoyun.f9933a63.png";